// extracted by mini-css-extract-plugin
export default {"flagCH":"icon_flagCH__4qcEM","flagUS":"icon_flagUS__Qh1lW","flagEU":"icon_flagEU__63PeM","flagGB":"icon_flagGB__Mr1lM","flagCA":"icon_flagCA__PjGxs","flagCN":"icon_flagCN__4PMZp"};